import { AppLanguage } from '../types/language.types';

export const useLanguages = () => {
  const languages = [
    {
      value: AppLanguage.EN,
      label: 'English',
      icon: <img src="/images/languages/en-flag.svg" alt="English" />,
    },
    {
      value: AppLanguage.PL,
      label: 'Polski',
      icon: <img src="/images/languages/pl-flag.svg" alt="Polski" />,
    },
  ];

  return {
    languages,
  };
};
